<template>
  <admin-template subtitle="Hirers" :headerButton="headerButton" @onButtonClicked="onRegister">
    <sidebar-modal :active.sync="showSidebar" :title="sidebarTitle"
      :loading="sidebarLoading" :button="sidebarButton"
      :destroyLoading='destroyLoading'
      :destructive="destructiveButton"
      v-on:action="onSidebarAction"
      v-on:destroy="onSidebarDestroy"
      :error.sync="sidebarError">
      <component v-bind:is="sidebarComponent"></component>
    </sidebar-modal>
    <div class="m-t-32">
      <hirer-list v-if="hirers.length > 0 && !hirerLoading" :hirers="hirers" @click="onEdit" />
      <row-skeleton :right="true" v-else-if="hirerLoading"></row-skeleton>
      <empty-state v-else title="No Hirers" icon="empty-state-eyes" >
        <template slot="content">
          No Hirer to see here, yet.
        </template>
      </empty-state>
    </div>
  </admin-template>
</template>

<script>
import AdminTemplate from './admin-sub'
import SidebarModal from '@/components/sidebar-modal'
import HirerForm from '../../components/admin/hirer/hirer-form'
import HirerList from '../../components/admin/hirer/hirer-list'
import HirerDetail from '@/components/admin/hirer/hirer-detail'
import EmptyState from '@/components/general/empty-state'
import Banner from '@/components/general/banner'
import RowSkeleton from '@/components/general/row-skeleton'
import { mapState, mapActions, mapMutations } from 'vuex'
import Jobs from '../../api/jobs'

export default {
  name: 'adminHieres',
  components: { RowSkeleton, AdminTemplate, SidebarModal, HirerForm, HirerList, EmptyState, HirerDetail, Banner },
  computed: {
    ...mapState('adminHirers', ['hirers', 'hirerLoading']),
    ...mapState('users', ['user']),
    headerButton () {
      if (this.user && this.user.profile === 'jobboardowner') {
        return ''
      }
      return 'Register Hirer'
    }
  },
  async mounted () {
    const boards = await Jobs.getJobBoards()

    if (this.user.profile === 'jobboardowner') {
      if (boards.length > 0) {
        this.getJobBoardOwnerHirers(boards[0].id)
      }
    } else {
      this.getHirers()
    }
  },
  methods: {
    ...mapMutations('hirerForm', ['clear']),
    ...mapActions('hirerForm', ['registerHirer', 'updateHirer']),
    ...mapActions('adminHirers', ['getHirers', 'getHirer', 'getJobBoardOwnerHirers']),
    onRegister () {
      this.clear()
      this.sidebarLoading = false
      this.showSidebar = true
      this.sidebarTitle = 'New Hirer'
      this.sidebarComponent = 'HirerForm'
      this.sidebarButton = 'Register Hirer'
      this.sidebarAction = 'registerHirer'
    },
    async onSidebarAction () {
      switch (this.sidebarAction) {
        case 'editHirer':
          try {
            this.sidebarLoading = true
            await this.updateHirer()
            this.sidebarLoading = false
            this.getHirers()
            this.showSidebar = false
            this.clear()
          } catch (err) {
            this.sidebarLoading = false
            if (err.response) {
              this.sidebarError = err.response.data
            } else {
              this.sidebarError = 'Something went wrong!'
            }
          }
          break
        case 'registerHirer':
          try {
            this.sidebarLoading = true
            await this.registerHirer()
            this.sidebarLoading = false
            this.getHirers()
            this.showSidebar = false
            this.clear()
          } catch (err) {
            this.sidebarLoading = false
            if (err.response) {
              this.sidebarError = err.response.data
            } else {
              this.sidebarError = 'Something went wrong!'
            }
          }
          break
      }
    },
    async onEdit (id) {
      this.clear()
      await this.getHirer(id)
      this.sidebarLoading = false
      this.showSidebar = true
      this.sidebarTitle = 'Edit Hirer'
      this.sidebarComponent = 'HirerForm'
      this.sidebarButton = 'Save'
      this.sidebarAction = 'editHirer'
    },
    onSidebarDestroy () {

    }
  },
  data () {
    return {
      sidebarTitle: '',
      sidebarComponent: '',
      showSidebar: false,
      sidebarLoading: false,
      sidebarButton: '',
      destructiveButton: '',
      dropdownActive: false,
      dropdownTitle: '',
      destroyLoading: false,
      sidebarError: null,
      sidebarAction: null,
      sidebarMessage: null
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/admin/hirers.vue